// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Velg',
    titleLinkTooltip: 'Gå til siden',
    collapseCardTooltip: 'Slå sammen kortet',
    expandCardTooltip: 'Utvid kortet'
  },
  CardList: {
    loadMore: 'Last inn flere',
    notFound: 'Fant ingen elementer.',
    toolbarSelect: 'Velg',
    viewCards: 'Kort',
    viewTiles: 'Fliser',
    viewList: 'Liste',
    toolbarView: 'Vis'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Avslutt',
    cancel: 'Gå tilbake',
    content: 'Er du sikker på at du vil avslutte og lukke dette vinduet? Endringene du har gjort, blir ikke lagret.'
  },
  Cuttable: {
    showMore: 'Vis mer',
    showLess: 'Vis mindre'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Avbryt'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Avbryt'
  },
  Dropdown: {
    close: 'Lukk'
  },
  Form: {
    submitButton: 'Lagre',
    applyButton: 'Bruk',
    cancelButton: 'Avbryt'
  },
  FormField: {
    clear: 'Tøm',
    remove: 'Fjern',
    addMore: 'Legg til ett til',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Slik forbedrer du passordet:',
    passwordTooShort: 'Gjør passordet lengre.',
    lettersLowerCase: 'Bruk minst én liten bokstav.',
    lettersUpperCase: 'Bruk minst én stor bokstav.',
    numbers1: 'Bruk minst ett tall.',
    numbers3: 'Bruk minst tre tall.',
    specialChar1: 'Bruk minst ett spesialtegn (for eksempel: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Bruk minst to spesialtegn (for eksempel: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Bruk både små og store bokstaver.',
    comboLettersAndNumbers: 'Bruk både tall og bokstaver.',
    comboLettersNumbersSpecial: 'Bruk tall, bokstaver og spesialtegn.',
    yourPasswordIsStrong: 'Du kan gjøre passordet enda sterkere ved å gjøre det lengre.',
    passwordStrength: 'Passordet er %%strength%%.',
    strengthVeryStrong: 'VELDIG STERKT',
    strengthStrong: 'STERKT',
    strengthVeryWeak: 'VELDIG SVAKT',
    strengthWeak: 'SVAKT',
    strengthMedium: 'MIDDELS',
    hidePassword: 'Skjul passordet',
    showPassword: 'Vis passordet',
    generateButton: 'Generer',
    copyButtonHint: 'Kopier passordet',
    copySuccessToast: 'Passordet ble kopiert',
    generateButtonHint: 'Generer et sterkt passord'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Forkast endringene',
    editButtonHint: 'Endre verdi',
    okButtonHint: 'Lagre endringene'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Velg fil...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '%%totalRows%% elementer totalt',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% av %%totalRows%% elementer er valgt',
    all: 'Alle',
    allItemsOnPageSelected: 'Alle elementene på siden er valgt',
    allItemsSelected: 'Alle elementene er valgt',
    selectAllItems: 'Velg alle elementene',
    selectAllItemsOnPage: 'Velg alle elementene på siden',
    deselectAll: 'Fjern valg',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Fant ingen elementer som stemmer med filteret',
    emptyTitle: 'Det er ingenting her',
    filteredDescription: 'Begrens søket eller fjern noen av kriteriene fra filteret, og prøv igjen.'
  },
  ListOperation: {
    cancelButton: 'Avbryt'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'av %%total%%',
    itemsPerPage: 'Elementer per side',
    all: 'Alle',
    total: 'Side %%current%% av %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Lukk',
    cancelButton: 'Avbryt'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Ingen alternativer',
    placeholder: 'Velg...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% av %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Lukk gruppen'
  },
  Toast: {
    closeButton: 'Close'
  }
};